
import deferred from 'vue-deferred'
import { defineAsyncComponent } from 'vue'
import { $vfm } from 'vue-final-modal'

export default function() {
  function makeid(length) {
    var result = ''
    var characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    var charactersLength = characters.length
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  }


}
